import React from 'react';
import { digitalShowroom } from '../mock';

export default function DigitalShowroom() {
  return (
    <section className="w-full bg-white py-20 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="text-[11px] tracking-[0.4em] uppercase text-[#7a1a2a] mb-3">Innovation</div>
          <h2 className="serif text-4xl md:text-5xl font-light text-[#1a1a1a] mb-3">Transform Your Spaces Effortlessly</h2>
          <p className="text-[15px] text-[#6b6b6b] max-w-3xl mx-auto font-light leading-relaxed">
            Browse the complete range of Simpolo tiles online, explore 3D tile previews, and visualize how different floor tiles and wall tiles will look in your space.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {digitalShowroom.map((s) => (
            <a href="#" key={s.titleAccent} className="group relative block h-80 md:h-[440px] img-zoom bg-neutral-100">
              <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-8 md:p-12 text-white">
                <h3 className="serif text-3xl md:text-4xl font-light leading-tight mb-1">{s.title}</h3>
                <h3 className="serif text-3xl md:text-4xl font-light italic text-[#e6c98f] leading-tight mb-5">{s.titleAccent}</h3>
                <span className="link-underline text-white w-fit">Discover <span aria-hidden>&rarr;</span></span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
